"use client"
import { useState, useEffect } from "react"
import { Skeleton } from "@/components/ui/skeleton"

interface FlagIconProps {
  country: string
  className?: string
}

export function FlagIcon({ country, className = "" }: FlagIconProps) {
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(false)

  // Convert country code to lowercase for the API
  const countryCode = country.toLowerCase()

  // Flag API URL - using flagcdn.com which provides free flag images
  const flagUrl = `https://flagcdn.com/w40/${countryCode}.png`

  // Handle image load complete
  const handleImageLoad = () => {
    setIsLoading(false)
  }

  // Handle image load error
  const handleImageError = () => {
    setIsLoading(false)
    setError(true)
  }

  // Reset loading state when country changes
  useEffect(() => {
    setIsLoading(true)
    setError(false)
  }, [country])

  return (
    <div className="relative w-5 h-3.5 flex items-center justify-center">
      {isLoading && <Skeleton className="absolute inset-0 w-full h-full rounded-sm" />}

      {error ? (
        <div className={`w-5 h-3.5 bg-gray-200 flex items-center justify-center text-xs ${className}`}>
          {countryCode.toUpperCase()}
        </div>
      ) : (
        <img
          src={flagUrl || "/placeholder.svg"}
          alt={`Flag of ${countryCode}`}
          className={`w-5 h-3.5 object-cover rounded-xs ${className} ${isLoading ? "opacity-0" : "opacity-100"}`}
          onLoad={handleImageLoad}
          onError={handleImageError}
        />
      )}
    </div>
  )
}
